import tw, { styled } from 'twin.macro';
import 'styled-components/macro';

import { Maybe } from 'types/graphql';

export interface ThemeableBackgroundContainerProps {
  backgroundColor?: Maybe<string>;
  backgroundURL?: Maybe<string>;
  foregroundColor?: Maybe<string>;
}

export const ThemeableBackgroundContainer = styled.div(
  ({ backgroundColor, backgroundURL, foregroundColor }: ThemeableBackgroundContainerProps) => [
    tw`bg-cover bg-primary text-white`,
    {
      backgroundColor: backgroundColor ?? undefined,
      backgroundImage: backgroundURL ? `url(${backgroundURL})` : undefined,
      color: foregroundColor ?? undefined,
    },
  ],
);
